<template>
	<div class="text-center">
		<menu-acoes
			nome-botao="Gerar Ata"
			nome="Gerar Ata"
			v-az-auth="permissoes.ataComProcessoCriar"
			cor-icone="--v-error-base"
			icone-primary="mdi-plus-circle"
			icone-secondary="mdi-menu-down"
			:acoes-menu="itens"
			tamanho-icone-primary="0.9rem"
			tamanho-icone-secondary="0.9rem"
			tamanho-icone-menu="18px"
			@abrir-modal-ata-com-processo="abrirOuFecharModal"
			@abrir-modal-ata-sem-processo="abrirModalAtaSemProcesso"
		>
		</menu-acoes>

		<modal-ata-com-processo
			:exibir="exibirModalAtaComProcesso"
			@fechar-modal="abrirOuFecharModal"
		></modal-ata-com-processo>
	</div>
</template>

<script>
import ModalAtaComProcesso from '@/views/pages/ata/gerar-ata/com-processo/modal/ModalAtaComProcesso.vue'
import { permissoes } from '@/core/constants'

export default {
	name: 'menu-criacao-ata',
	components: { ModalAtaComProcesso },
	data() {
		return {
			itens: [
				{
					titulo: 'Com Processo',
					icone: {
						nome: 'mdi-text-box-outline',
					},
					evento: 'abrir-modal-ata-com-processo',
					authorization: permissoes.ataComProcessoCriar,
				},
				// {
				// 	titulo: 'Sem Processo', // colocar a permissão no menu-acoes
				// 	icone: {
				// 		nome: 'mdi-file-document-remove-outline',
				// 	},
				// 	evento: 'abrir-modal-ata-sem-processo',
				// 	authorization: '',
				// },
			],
			exibirModalAtaComProcesso: false,
		}
	},
	methods: {
		abrirOuFecharModal() {
			this.exibirModalAtaComProcesso = !this.exibirModalAtaComProcesso
		},

		abrirModalAtaSemProcesso() {
			alert('não possui funcionalidade')
		},
	},
}
</script>

<style scoped></style>
